import {
  IFullPlanDetailPPO,
  ICustomBenefitPrescriptionPPO,
  IFullPlanDetail,
  IBenefit,
  ICustomBenefitPrescription,
} from "../interfaces/api";

export const getDoubleDataPPO = (data: IFullPlanDetailPPO, title: string) => {
  let benefit: ICustomBenefitPrescriptionPPO = {
    group: {
      groupName: "",
    },
    pbpBenefitGroup: {
      pbpBenefitName: "",
      InNetwork: "",
      OutofNetwork: "",
    },
  };

  data.CustomBenefits &&
    data.CustomBenefits.forEach((group) => {
      if (group.pbpBenefitGroup.pbpBenefitName === title) {
        benefit = group;
      }
    });
  return benefit;
};

export const getDoubleDeepHMO = (
  data: IFullPlanDetail,
  title1: string,
  title2: string
) => {
  let benefits: IBenefit[] = [];

  let compareData = [];

  data.PlanDetails[0].company[0].healthPlan[0].pbp[0].group.forEach((group) => {
    if (group.pbpBenefitGroup) {
      group.category.forEach((category, idx) => {
        if (category.pbpBenefitCategory === (title1 as string)) {
          category.benefit.forEach((benefit) => {
            if (benefit.pbpBenefitName === (title2 as string)) {
              benefits.push(benefit);
              compareData[idx] = benefit;
            }
          });
        }
      });
    }
  });

  return benefits;
};

export const getSingleDeepHMO = (data: IFullPlanDetail, title: string) => {
  let inpatientHospitalBenefit: IBenefit[] = [];

  data.PlanDetails[0].company[0].healthPlan[0].pbp[0].group.forEach((group) => {
    if (group.pbpBenefitGroup) {
      group.category.forEach((category) => {
        if (category.pbpBenefitCategory === (title as string)) {
          inpatientHospitalBenefit = category.benefit;
        }
      });
    }
  });

  return inpatientHospitalBenefit;
};

export const getTierHMO = (data: IFullPlanDetail, title: string) => {
  let benefit: ICustomBenefitPrescription = {
    group: {
      groupName: "",
    },
    pbpBenefitGroup: {
      pbpBenefitName: "",
      RetailStandard: "",
      MailOrderStandard: "",
    },
  };

  data.CustomBenefitPrescription &&
    data.CustomBenefitPrescription.forEach((group) => {
      if (group.pbpBenefitGroup.pbpBenefitName === title) {
        benefit = group;
      }
    });
  return benefit;
};

export const getTierPPO = (data: IFullPlanDetailPPO, title: string) => {
  let benefit: ICustomBenefitPrescription = {
    group: {
      groupName: "",
    },
    pbpBenefitGroup: {
      pbpBenefitName: "",
      RetailStandard: "",
      MailOrderStandard: "",
    },
  };

  data.CustomBenefitPrescription &&
    data.CustomBenefitPrescription.forEach((group) => {
      if (group.pbpBenefitGroup.pbpBenefitName === title) {
        benefit = group;
      }
    });
  return benefit;
};

export const getTierPPOO = (data: IFullPlanDetailPPO, title: string) => {
  let benefit: ICustomBenefitPrescription = {
    group: {
      groupName: "",
    },
    pbpBenefitGroup: {
      pbpBenefitName: "",
      RetailStandard: "",
      MailOrderStandard: "",
    },
  };

  data.CustomBenefitPrescription &&
    data.CustomBenefitPrescription.forEach((group) => {
      if (group.pbpBenefitGroup.pbpBenefitName === title) {
        benefit = group;
      }
    });
  return benefit;
};

export const getDoubleDeepPPO = (
  data: IFullPlanDetailPPO,
  title1: string,
  title2: string
) => {
  let benefits: IBenefit[] = [];

  let compareData = [];

  data.PlanDetails[0].company[0].healthPlan[0].pbp[0].group.forEach((group) => {
    if (group.pbpBenefitGroup) {
      group.category.forEach((category, idx) => {
        if (category.pbpBenefitCategory === (title1 as string)) {
          category.benefit.forEach((benefit) => {
            if (benefit.pbpBenefitName === (title2 as string)) {
              benefits.push(benefit);
              compareData[idx] = benefit;
            }
          });
        }
      });
    }
  });

  return benefits;
};
